import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormGroup, Label } from "reactstrap";
import {
  createSupplierReturnNotes,
  getAllDocumentList,
  getCustomerAddressList,
  getDeductionList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getMoloniVehiclesList,
  getTaxList,
  viewSupplierReturnNotes,
  updateSupplierReturnNotes,
  getMaturityDatesList,
  getListSalesmenList,
  getDeliveryNotesList,
  getListSupplierList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";



const AddSupplierReturnNotes = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [supplierReturnNotesData, setSupplierReturnNotesData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    supplier_id: "",
    your_reference: "",
    our_reference: "",
    related_documents_notes: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    notes: "",
    status: 0,
    financial_discount: "",
    associate_document_type: "",
  });

  const [supplierCreditViewData, setSupplierCreditViewData] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    supplier_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [suppliersDataList, setSuppliersDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);

  const [exemptionList, setExemptionList] = useState([]);
  
  
  
    useEffect(function () {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        type: "exception_list",
      };
      getCommonSearchList(data)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].code,
              label: response.data[i].description,
            });
          }
  
          setExemptionList(list);
        })
        .catch((err) => {});
    }, []);

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];
    list.push({ ...initialProduct });

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];
    list.splice(index, 1);

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...supplierReturnNotesData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setSupplierReturnNotesData({ ...supplierReturnNotesData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...supplierReturnNotesData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setSupplierReturnNotesData({ ...supplierReturnNotesData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...supplierReturnNotesData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setSupplierReturnNotesData({
      ...supplierReturnNotesData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_invoice",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSupplierList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSuppliersDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewSupplierReturnNotes(data)
        .then((response) => {
          setSupplierCreditViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/supplierReturnNotes");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (supplierCreditViewData) {
      setSupplierReturnNotesData({
        id: supplierCreditViewData?.id,
        date: supplierCreditViewData?.date,
        document_set_id: supplierCreditViewData?.document_set_id,
        supplier_id: supplierCreditViewData?.supplier_id,
        your_reference: supplierCreditViewData?.your_reference,
        our_reference: supplierCreditViewData?.our_reference,
        products: supplierCreditViewData?.products,
        exchange_currency_id: supplierCreditViewData?.exchange_currency_id,
        exchange_rate: supplierCreditViewData?.exchange_rate,
        notes: supplierCreditViewData?.notes,
        status: supplierCreditViewData?.status,
        financial_discount: supplierCreditViewData?.financial_discount,
        associate_document_type:
          supplierCreditViewData?.associate_document_type,
      });
    }
  }, [supplierCreditViewData]);

  useEffect(() => {
    if (!supplierReturnNotesData?.customer_id) {
      return;
    }

    if (Number(supplierReturnNotesData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierReturnNotesData.customer_id,
      };

      getDeliveryNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [
    supplierReturnNotesData,
    supplierReturnNotesData?.associate_document_type,
  ]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setSupplierReturnNotesData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!supplierReturnNotesData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierReturnNotesData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierReturnNotesData.supplier_id) {
      errorObj.supplier_id = `Supplier is required.`;
      error = true;
      setBtnLoader(false);
    }

    let allValid = true;
    supplierReturnNotesData?.products.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: supplierReturnNotesData?.date,
      document_set_id: supplierReturnNotesData?.document_set_id,
      supplier_id: supplierReturnNotesData?.supplier_id,
      your_reference: supplierReturnNotesData?.your_reference,
      our_reference: supplierReturnNotesData?.our_reference,
      products: supplierReturnNotesData?.products,
      exchange_currency_id: supplierReturnNotesData?.exchange_currency_id,
      exchange_rate: supplierReturnNotesData?.exchange_rate,
      notes: supplierReturnNotesData?.notes,
      status: supplierReturnNotesData?.status,
      financial_discount: supplierReturnNotesData?.financial_discount,
    };

    let updateData = {
      id: supplierReturnNotesData?.id,
      document_id: supplierCreditViewData?.document_id,
      date: supplierReturnNotesData?.date,
      document_set_id: supplierReturnNotesData?.document_set_id,
      supplier_id: supplierReturnNotesData?.supplier_id,
      your_reference: supplierReturnNotesData?.your_reference,
      our_reference: supplierReturnNotesData?.our_reference,
      products: supplierReturnNotesData?.products,
      exchange_currency_id: supplierReturnNotesData?.exchange_currency_id,
      exchange_rate: supplierReturnNotesData?.exchange_rate,
      notes: supplierReturnNotesData?.notes,
      status: supplierReturnNotesData?.status,
      financial_discount: supplierReturnNotesData?.financial_discount,
    };

    if (supplierCreditViewData?.id) {
      updateSupplierReturnNotes(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierReturnNotes");
          setSupplierReturnNotesData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSupplierReturnNotes(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierReturnNotes");
          setSupplierReturnNotesData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
              </div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{t("supplierReturnNotes")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierReturnNotesData.date}
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      supplierReturnNotesData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("supplier")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={suppliersDataList}
                                  value={suppliersDataList.find(
                                    (item) =>
                                      item.value ===
                                      supplierReturnNotesData.supplier_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      supplier_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Customer"}
                                />
                                {errors.supplier_id && (
                                  <span className="input-error">
                                    {errors.supplier_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("financial_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    supplierReturnNotesData.financial_discount
                                  }
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      financial_discount: e.target.value,
                                    });
                                  }}
                                  name="financial_discount"
                                  placeholder="Financial Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("your_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierReturnNotesData.your_reference}
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      your_reference: e.target.value,
                                    });
                                  }}
                                  name="your_reference"
                                  placeholder="Your Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("our_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierReturnNotesData.our_reference}
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      our_reference: e.target.value,
                                    });
                                  }}
                                  name="our_reference"
                                  placeholder="Our Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_currency")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      supplierReturnNotesData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_rate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={supplierReturnNotesData.exchange_rate}
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierReturnNotesData.notes}
                                  onChange={(e) => {
                                    setSupplierReturnNotesData({
                                      ...supplierReturnNotesData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("status")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={
                                      supplierReturnNotesData.status === 1
                                    }
                                    onChange={(e) => {
                                      setSupplierReturnNotesData({
                                        ...supplierReturnNotesData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {supplierReturnNotesData?.products?.map(
                            (product, i) => (
                              <div key={i} className="card p-3 mb-3">
                                <h5>Product {i + 1}</h5>
                                <div className="row">
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("product")}
                                      </Label>
                                      <Select
                                        className="my-select-v"
                                        options={productList}
                                        value={productList.find(
                                          (item) =>
                                            item.value ===
                                            String(
                                              supplierReturnNotesData.products[
                                                i
                                              ].product_id,
                                            ),
                                        )}
                                        onChange={(selectedOption) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].product_id = selectedOption
                                            ? selectedOption.value
                                            : null;
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i); // validation
                                          setSelectedProduct(selectedOption);
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Product"}
                                      />
                                      {errorsPro[i]?.product_id && (
                                        <small className="text-danger">
                                          {errorsPro[i].product_id}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("name")}
                                      </Label>
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="Name"
                                        value={product.name}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].name = e.target.value;
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i); //validation
                                        }}
                                      />
                                      {errorsPro[i]?.name && (
                                        <small className="text-danger">
                                          {errorsPro[i].name}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("summary")}
                                      </Label>
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="Summary"
                                        value={product.summary}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].summary = e.target.value;
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("quantity")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Quantity"
                                        value={product.qty}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].qty = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i);
                                        }}
                                      />
                                      {errorsPro[i]?.qty && (
                                        <small className="text-danger">
                                          {errorsPro[i].qty}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("price")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Price"
                                        value={product.price}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].price = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i);
                                        }}
                                      />
                                      {errorsPro[i]?.price && (
                                        <small className="text-danger">
                                          {errorsPro[i].price}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("discount")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Discount"
                                        value={product.discount}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].discount = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("deduction")}
                                      </Label>
                                      <Select
                                        className="my-select-v"
                                        options={deductionList}
                                        value={deductionList.find(
                                          (item) =>
                                            item.value ===
                                            supplierReturnNotesData.products[i]
                                              .deduction_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].deduction_id = selectedOption
                                            ? selectedOption.value
                                            : null;
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Deduction"}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("order")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Order"
                                        value={product.order}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierReturnNotesData.products,
                                          ];
                                          list[i].order = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierReturnNotesData({
                                            ...supplierReturnNotesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("exemption_reason")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={exemptionList}
                                            value={exemptionList.find(
                                              (item) =>
                                                item.value ===
                                                supplierReturnNotesData
                                                  .products[i].exemption_reason,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...supplierReturnNotesData.products,
                                              ];
                                              list[i].exemption_reason =
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                              setSupplierReturnNotesData({
                                                ...supplierReturnNotesData,
                                                products: list,
                                              });
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Exemption Reason"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3"></div>

                                  <div className="col-md-3"></div>
                                  <div className="col-md-3"></div>

                                  <div className="row">
                                    <div
                                      className="col-md-12"
                                      style={{
                                        marginTop: "15px",
                                        marginBottom: "15px",
                                      }}
                                    >
                                      {" "}
                                      <h5>{t("tax")}</h5>
                                      <button
                                        className="btn btn-primary"
                                        onClick={(e) => handleAddTax(e, i)}
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                    </div>
                                    {product?.taxes?.length > 0 ? (
                                      <div
                                        className="row justify-content-start"
                                        style={{
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {product?.taxes?.map((prop, j) => (
                                          <div className="col-md-6">
                                            <div className="fileupload-content px-4">
                                              <div
                                                className="row justify-content-start align-items-center mb-2"
                                                key={j}
                                              >
                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("tax")}
                                                    </Label>
                                                    <Select
                                                      className="my-select-v"
                                                      options={taxDataList}
                                                      value={taxDataList.find(
                                                        (item) =>
                                                          item.value ===
                                                          String(
                                                            supplierReturnNotesData
                                                              .products[i]
                                                              .taxes[j].tax_id,
                                                          ),
                                                      )}
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        let list = [
                                                          ...supplierReturnNotesData.products,
                                                        ];
                                                        list[i].taxes[
                                                          j
                                                        ].tax_id =
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : null;
                                                        setSupplierReturnNotesData(
                                                          {
                                                            ...supplierReturnNotesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                      isSearchable={true}
                                                      isClearable={true}
                                                      placeholder={"Select Tax"}
                                                    />
                                                  </FormGroup>
                                                </div>

                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("value")}
                                                    </Label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Value"
                                                      value={prop.value}
                                                      onChange={(e) => {
                                                        let list = [
                                                          ...supplierReturnNotesData.products,
                                                        ];
                                                        list[i].properties[
                                                          j
                                                        ].value =
                                                          e.target.value;
                                                        setSupplierReturnNotesData(
                                                          {
                                                            ...supplierReturnNotesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </div>
                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("order")}
                                                    </Label>
                                                    <input
                                                      type="Number"
                                                      className="form-control"
                                                      placeholder="Order"
                                                      value={prop.order}
                                                      onChange={(e) => {
                                                        let list = [
                                                          ...supplierReturnNotesData.products,
                                                        ];
                                                        list[i].taxes[j].order =
                                                          e.target.value;
                                                        setSupplierReturnNotesData(
                                                          {
                                                            ...supplierReturnNotesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </div>

                                                <div className="col-md-4 d-flex align-item-center">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("cumulative")}
                                                    </Label>
                                                    <div className="col-xl-12">
                                                      <div className="input-div">
                                                        <div className="form-check">
                                                          <input
                                                            className="my-checkbox-1 form-check-input"
                                                            type="checkbox"
                                                            checked={
                                                              prop.cumulative ===
                                                              1
                                                            }
                                                            onChange={(e) => {
                                                              let list = [
                                                                ...supplierReturnNotesData.products,
                                                              ];
                                                              list[i].taxes[
                                                                j
                                                              ].cumulative = e
                                                                .target.checked
                                                                ? 1
                                                                : 0;
                                                              setSupplierReturnNotesData(
                                                                {
                                                                  ...supplierReturnNotesData,
                                                                  products:
                                                                    list,
                                                                },
                                                              );
                                                            }}
                                                          />
                                                          <label className="form-check-label pl-2">
                                                            {t("Cumulative")}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </FormGroup>
                                                </div>

                                                <div className="d-flex align-item-center">
                                                  <button
                                                    className="btn btn-danger"
                                                    onClick={(e) =>
                                                      handleRemoveTax(e, i, j)
                                                    }
                                                  >
                                                    <i className="bi bi-trash"></i>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <p className="text-muted">
                                        No tax list added.
                                      </p>
                                    )}
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(e) => handleRemoveProduct(e, i)}
                                >
                                  <i className="bi bi-trash"></i>
                                </button>

                                <div className="row d-none">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <h5>{t("child_products")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) =>
                                        handleAddChildProduct(e, i)
                                      }
                                      type="button"
                                    >
                                      + {t("add_child_product")}
                                    </button>
                                  </div>

                                  {product?.child_products?.map((child, k) => (
                                    <div
                                      key={k}
                                      className="card p-2 mb-2 border"
                                    >
                                      <h6>Child Product {k + 1}</h6>

                                      <div className="row">
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("child_name")}</Label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.name}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].name =
                                                  e.target.value;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("summary")}</Label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.summary}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].summary = e.target.value;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("quantity")}</Label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={child.qty}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].qty =
                                                  parseFloat(e.target.value);
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("price")}</Label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={child.price}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].price = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                      </div>

                                      {/* Properties Section for child */}
                                      <div className="row mt-2">
                                        <h6>{t("properties")}</h6>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={(e) =>
                                            handleAddChildProperty(e, i, k)
                                          }
                                          type="button"
                                        >
                                          + {t("add_property")}
                                        </button>
                                        {child?.properties?.map((prop, j) => (
                                          <div
                                            key={j}
                                            className="d-flex gap-2 mb-2"
                                          >
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Title"
                                              value={prop.title}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].properties[j].title =
                                                  e.target.value;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Value"
                                              value={prop.value}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].properties[j].value =
                                                  e.target.value;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </div>

                                      {/* Taxes Section for child */}
                                      <div className="row mt-2">
                                        <h6>{t("taxes")}</h6>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={(e) =>
                                            handleAddChildTax(e, i, k)
                                          }
                                          type="button"
                                        >
                                          + {t("add_tax")}
                                        </button>
                                        {child?.taxes?.map((tax, j) => (
                                          <div
                                            key={j}
                                            className="d-flex gap-2 mb-2"
                                          >
                                            <Select
                                              className="my-select-v"
                                              options={taxDataList}
                                              value={taxDataList.find(
                                                (item) =>
                                                  item.value === tax.tax_id,
                                              )}
                                              onChange={(selectedOption) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].tax_id = selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                              isSearchable
                                              isClearable
                                              placeholder="Select Tax"
                                            />
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Value"
                                              value={tax.value}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].value = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Order"
                                              value={tax.order}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].order = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                            <input
                                              type="checkbox"
                                              checked={tax.cumulative === 1}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierReturnNotesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].cumulative = e.target.checked
                                                  ? 1
                                                  : 0;
                                                setSupplierReturnNotesData({
                                                  ...supplierReturnNotesData,
                                                  products: list,
                                                });
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </div>

                                      {/* Remove child button */}
                                      <button
                                        className="btn btn-danger mt-2"
                                        onClick={(e) =>
                                          handleRemoveChildProduct(e, i, k)
                                        }
                                      >
                                        <i className="bi bi-trash"></i>{" "}
                                        {t("remove_child_product")}
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ),
                          )}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() => navigate("/supplierReturnNotes")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddSupplierReturnNotes;
